/* eslint-disable @typescript-eslint/no-empty-function */
import { Modals } from "component_old/modal/ModalTypes"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React, { createContext, useState } from "react"

export interface IModalCtx {
  modal: Modals
  changeModal: (type: Modals | null) => void
}

export const CtxModal = createContext<IModalCtx>(null)

export const ModalStateProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const isWide = useIsWide()
  const [modal, setModal] = useState<Modals>(null)

  const changeModal = (type: Modals | null) => {
    if (type) {
      document.querySelector("body").style.overflow = "hidden"
      if (isWide && document.body.clientHeight > window.innerHeight) {
        document.querySelector("body").style.borderRight = "15px solid #ffffff" //mimic scroll
      }
    } else {
      document.querySelector("body").style.overflow = "unset"
      if (isWide) {
        document.querySelector("body").style.borderRight = "unset"
      }
    }
    setTimeout(() => {
      setModal(type)
    }, 50) //maybe helps the browser to block scrolling
  }

  return (
    <CtxModal.Provider value={{ modal, changeModal }}>
      {children}
    </CtxModal.Provider>
  )
}
